import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

class ImagesViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: props.photoIndex,
    };
  }

  render() {
    const { images, close } = this.props;
    const { photoIndex } = this.state;
    const imageLinks = images.map(image => image.url);

    return (
      <Lightbox
        reactModalStyle={{
          overlay: {
            zIndex: 60000,
          },
        }}
        mainSrc={imageLinks[photoIndex]}
        nextSrc={imageLinks[(photoIndex + 1) % imageLinks.length]}
        prevSrc={imageLinks[(photoIndex + imageLinks.length - 1) % imageLinks.length]}
        onCloseRequest={close}
        onMovePrevRequest={() => this.setState({
          photoIndex: (photoIndex + imageLinks.length - 1) % imageLinks.length,
        })
        }
        onMoveNextRequest={() => this.setState({
          photoIndex: (photoIndex + 1) % imageLinks.length,
        })
        }
      />
    );
  }
}

ImagesViewer.propTypes = {
  images: PropTypes.array.isRequired,
  photoIndex: PropTypes.number.isRequired,
  close: PropTypes.func.isRequired,
};

export default ImagesViewer;



// WEBPACK FOOTER //
// ./src/components/ImagesViewer.jsx